import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// FONT AWESOME LIBRARY AND ICONS
import { faHandPointer } from "@fortawesome/free-solid-svg-icons";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import { updateActionFiringMode } from "../../redux/monitoring/monitoringSlice";
// COMPONENTS
import DrawerRowDivider from "../components/drawer/DrawerRowDivider";
import ActionFiringModeSelect from "../../components/actionFiringMode/ActionFiringModeSelect";
// UTILS
import { resolveConfiguredMode } from "../../utils/actionFiringMode";
// INTERFACES
import { RootState } from "../../app/store";

/**
 * The signed-in operator's own action-firing preference.
 *
 * Sits next to Appearance and Notifications because it is the same kind of
 * thing: a per-operator preference, not an administrative setting. It is
 * nonetheless permission-gated — ActionFiringModeSelect renders nothing without
 * the grant — because this preference decides whether a floor button dispatches
 * an elevator command on the first press, and a site may want that fixed for
 * everyone.
 */
function ActionFiringPreference() {
  const [t] = useTranslation("global");
  const dispatch = useDispatch();
  const { theme, userLogged } = useSelector((state: RootState) => state.home);

  return (
    <>
      <DrawerRowDivider
        icon={faHandPointer}
        title={t("actionFiringMode.sectionTitle", "Action Firing")}
      />
      <div className={`drawer__box__${theme}`} style={{ padding: "16px" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <ActionFiringModeSelect
                target={{ kind: "self" }}
                value={userLogged?.actionFiringMode}
                onSaved={(saved) => {
                  // The monitoring slice is what the dispatching surfaces read,
                  // and it is written once by the organization load path. Update
                  // it here too, or the operator saves a new preference and the
                  // Car Calls pad keeps behaving the old way until a reload.
                  dispatch(
                    updateActionFiringMode(
                      resolveConfiguredMode(saved, userLogged?.org?.actionFiringMode),
                    ),
                  );
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ActionFiringPreference;
